import { render, staticRenderFns } from "./AnimatedImage.vue?vue&type=template&id=5124188f&scoped=true&"
import script from "./AnimatedImage.vue?vue&type=script&lang=js&"
export * from "./AnimatedImage.vue?vue&type=script&lang=js&"
import style0 from "./AnimatedImage.vue?vue&type=style&index=0&id=5124188f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5124188f",
  null
  
)

export default component.exports